import { useState } from 'react';
import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
import { t } from '../i18n';
import {
    MDBBtn,
    MDBSwitch,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';

window.dataLayer = window.dataLayer || [];

const BmiCookieConsent = (props) => {
    const [cookiesModal, showCookiesModal] = useState(false);
    const [ccVisibility, setCcVisibility] = useState(true);
    const [performanceCookie, setPerformanceCookie] = useState(false);
    const [targetingCookie, setTargetingCookie] = useState(false);
    const bmiczCookie = getCookieConsentValue("BmiczCookieConsent");

    if (bmiczCookie != undefined) {
        var cookieValue = bmiczCookie.substring(7);
        var cookies = cookieValue.split(',');
        var perfCookie = cookies[1].slice(-1);
        if (perfCookie == 1) {
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        }
    }

    function gtag() { window.dataLayer.push(arguments); }

    function consentAll() {
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted'
        });
        var cookieValue = "groups=C0001:1,C0007:1,C0004:1"
        setCookie("BmiczCookieConsent", cookieValue, 365);
        setCcVisibility(false);
    }

    function denyAll() {
        gtag('consent', 'update', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
        });
        var cookieValue = "groups=C0001:1,C0007:0,C0004:0"
        setCookie("BmiczCookieConsent", cookieValue, 365);
        setCcVisibility(false);
    }

    function acceptSelected() {
        var cookieValue = "groups=C0001:1";
        if (performanceCookie) {
            cookieValue += ",C0007:1";
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        } else {
            cookieValue += ",C0007:0";
        }
        if (targetingCookie) {
            cookieValue += ",C0004:1";
        } else {
            cookieValue += ",C0004:0";
        }
        setCookie("BmiczCookieConsent", cookieValue, 365);
    }

    const cookiesModalBody = () => {
        return (
            <div className="">
                <h2 className="nadpis">{t("cookie_modal_title")}</h2>
                <div className="mb-3">
                    <p className="text-secondary mb-0">
                        {t("cookie_modal_intro")}
                    </p>
                    <a className="content-link" href="https://www.bmigroup.com/cz/cookies/" target="_blank">cookie-policy</a>
                </div>
                <button className="btn btn-primary" onClick={() => {
                    showCookiesModal(false);
                    consentAll();
                }}>
                    {t("cookie_allow_all")}
                </button>
                <section className="mt-5">
                    <h3 className="nadpis">{t("cookie_manage_title")}</h3>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">{t("cookie_necessary_title")}</h4>
                            <div className="c-primary fw-bold fs-4">{t("cookie_always_active")}</div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                {t("cookie_necessary_desc")}
                            </p>
                        </div>
                    </div>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">{t("cookie_performance_title")}</h4>
                            <div className="form-check form-switch">
                                <MDBSwitch defaultChecked={performanceCookie}
                                    onClick={(e) => setPerformanceCookie(e.target.checked)} />
                            </div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                {t("cookie_performance_desc")}
                            </p>
                        </div>
                    </div>
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold m-0 mx-2">{t("cookie_targeting_title")}</h4>
                            <div className="form-check form-switch">
                                <MDBSwitch defaultChecked={targetingCookie}
                                    onClick={(e) => setTargetingCookie(e.target.checked)} />
                            </div>
                        </div>
                        <div>
                            <p className="text-secondary mx-0 my-2 pe-5">
                                {t("cookie_targeting_desc")}
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    const ccbuttons = () => {
        return (
            <div className=''>
                <button className='btn btn-outline col-md-auto col-12' onClick={() => showCookiesModal(true)}>{t("cookie_settings_label")}</button>
                <button className='btn btn-outline col-md-auto col-12' onClick={() => denyAll()}>{t("cookie_deny_all")}</button>
                <button className='btn btn-primary col-md-auto col-12' onClick={() => consentAll()}>{t("cookie_accept_all")}</button>
            </div>
        );
    }

    return (bmiczCookie == undefined) ? (
        <span>
            <CookieConsent
                location="bottom"
                visible={ccVisibility}
                cookieName="BmiczCookieConsent"
                buttonText={t("cookie_accept_all")}
                onAccept={() => consentAll()}
                disableStyles={true}
                containerClasses="cookie-consent-banner p-3"
                contentClasses="col-lg-6 col-12 align-items-center d-flex"
                buttonWrapperClasses="col-lg-6 col-12"
                ButtonComponent={ccbuttons}
            >
                <p className="small">
                    {t("cookie_banner_text")}&nbsp;
                    <a href="https://www.bmigroup.com/cz/cookies/" className="content-link">cookie-policy</a>
                </p>
            </CookieConsent>
            <MDBModal open={cookiesModal} tabIndex='-1' onClose={() => showCookiesModal(false)}>
                <MDBModalDialog scrollable size='lg'>
                    <MDBModalContent className='p-2'>
                        <MDBModalHeader>
                            <MDBModalTitle className='text-uppercase'>{t("cookie_settings_label")}</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => showCookiesModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {cookiesModalBody()}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <button className='btn btn-secondary' onClick={() => {
                                showCookiesModal(false);
                                denyAll();
                            }}>
                                {t("cookie_deny_all")}
                            </button>
                            <button className=' btn btn-primary' onClick={() => {
                                showCookiesModal(false);
                                acceptSelected();
                            }}>
                                {t("cookie_confirm_choices")}
                            </button>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </span>
    ) : (<span></span>);

}

export default BmiCookieConsent;


function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=Lax; Secure";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
